export const DEFAULT_LANG = "en";

export const LANGUAGES = [
  { code: "en", name: "English" },
  { code: "es", name: "Español" },
  { code: "de", name: "Deutsch" },
  { code: "fr", name: "Français" },
  { code: "nl", name: "Nederlands" },
  { code: "sv", name: "Svenska" },
  { code: "no", name: "Norsk" },
  { code: "da", name: "Dansk" },
  { code: "fi", name: "Suomi" },
  { code: "pl", name: "Polski" },
  { code: "ru", name: "Русский" },
  { code: "it", name: "Italiano" },
  { code: "pt", name: "Português" },
  { code: "ar", name: "العربية" },
  { code: "zh", name: "中文" },
  { code: "cs", name: "Čeština" },
  { code: "ro", name: "Română" },
];

export const LANG_CODES = LANGUAGES.map((l) => l.code);
export const PREFIXED_LANGS = LANG_CODES.filter((c) => c !== DEFAULT_LANG);

let currentLang = DEFAULT_LANG;
export const getCurrentLang = () => currentLang;
export const setCurrentLang = (l) => {
  currentLang = l;
};

// "/es/developments/x" -> { lang: "es", basePath: "/developments/x" }
export function splitLangPath(pathname = "/") {
  const seg = pathname.split("/")[1];
  if (PREFIXED_LANGS.includes(seg)) {
    const rest = pathname.slice(seg.length + 1);
    return { lang: seg, basePath: rest || "/" };
  }
  return { lang: DEFAULT_LANG, basePath: pathname || "/" };
}

export function localizePath(to, lang = currentLang) {
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) return to;
  if (to.startsWith("/admin") || to.startsWith("/api")) return to;
  const { basePath } = splitLangPath(to.split(/[?#]/)[0]);
  const suffix = to.slice(to.split(/[?#]/)[0].length);
  if (lang === DEFAULT_LANG) return `${basePath}${suffix}`;
  return `${basePath === "/" ? `/${lang}` : `/${lang}${basePath}`}${suffix}`;
}
